<se-fe-modal-button
  class="desktop-header-button"
  [seFeDataButton]="{label: 'Set all products to active', secondary: true}"
  (seFeButtonAction)="setToActiveModal.open($event)"
  data-testid="set-to-active-button-desktop"></se-fe-modal-button>

<se-fe-modal #setToActiveModal [seFeDataActions]="modalButtons" (seFeClose)="setToActiveModal.close()">
  <div seFeModalHeader>
    <se-fe-modal-header [seFeDataTitle]="'Set all products to active?'"></se-fe-modal-header>
  </div>
  <div seFeModalContent>
    <p>This will change the status of all products in this bundle to active, making them available for sale.</p>
  </div>
</se-fe-modal>
